import api from "../helpers/api"

class Country{

    async fetch_countries(){
        return await api.get('/countries').then(
            response =>{
                return response.data
            }
        )
    }
}

export default new Country